(function () {
  'use strict';

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function initShell(shell) {
    if (shell.getAttribute('data-ss-demo-page-init') === 'true') {
      return;
    }
    shell.setAttribute('data-ss-demo-page-init', 'true');

    var startBtn = shell.querySelector('[data-ss-demo-page-start]');
    var gate = shell.querySelector('[data-ss-demo-page-gate]');
    var iframe = document.querySelector('[data-ss-planner-demo-iframe][data-src]');
    if (!iframe) return;

    var loadingEl = shell.querySelector('[data-ss-demo-page-loading]');
    var errorEl = shell.querySelector('[data-ss-demo-page-error]');
    var statusEl = shell.querySelector('[data-ss-demo-page-status]');

    function setStatus(message) {
      if (statusEl) {
        statusEl.textContent = message || '';
      }
    }

    function showError(container, message) {
      if (gate) gate.hidden = false;
      if (loadingEl) loadingEl.hidden = true;
      if (errorEl) {
        errorEl.hidden = false;
        var p = errorEl.querySelector('[data-ss-demo-page-error-text]');
        if (p) p.textContent = message;
      }
      if (startBtn) startBtn.disabled = false;
      setStatus(message);
    }

    var src = iframe.getAttribute('data-src');
    if (!src || src.indexOf('/pages/') !== -1 || src.indexOf('/products/') !== -1) {
      showError(gate, 'Demo could not be configured safely. Please refresh or contact support.');
      return;
    }

    function beginLoad() {
      if (errorEl) errorEl.hidden = true;
      if (startBtn) startBtn.hidden = true;
      var preview = gate && gate.querySelector('.ss-planner-demo-shell__preview');
      if (preview) preview.hidden = true;
      if (loadingEl) loadingEl.hidden = false;
      setStatus('Loading interactive demo…');

      iframe.addEventListener(
        'load',
        function onLoad() {
          iframe.removeEventListener('load', onLoad);
          if (loadingEl) loadingEl.hidden = true;
          if (gate) gate.hidden = true;
          setStatus('');
          iframe.removeAttribute('aria-hidden');
          var frameWrap =
            iframe.closest('[data-calmly-kept-demo-frame]') ||
            iframe.closest('[data-clear-days-demo-frame]') ||
            iframe.closest('[data-budget-bills-demo-frame]');
          if (frameWrap) frameWrap.classList.add('is-loaded');
        },
        { once: true }
      );

      iframe.addEventListener(
        'error',
        function onErr() {
          iframe.removeEventListener('error', onErr);
          showError(gate, 'The demo did not load. Check your connection and try again.');
        },
        { once: true }
      );

      iframe.src = src;
      scheduleLoadWatch(iframe, gate, loadingEl, errorEl, showError);
    }

    function scheduleLoadWatch(iframeEl, gateEl, loadingElRef, errorElRef, showErrorFn) {
      var frameWrap =
        iframeEl.closest('[data-calmly-kept-demo-frame]') ||
        iframeEl.closest('[data-clear-days-demo-frame]') ||
        iframeEl.closest('[data-budget-bills-demo-frame]');
      var timeoutMs = 45000;
      if (iframeEl._ssDemoLoadTimer) clearTimeout(iframeEl._ssDemoLoadTimer);
      iframeEl._ssDemoLoadTimer = setTimeout(function () {
        if (frameWrap && frameWrap.classList.contains('is-loaded')) return;
        showErrorFn(gateEl, 'The demo is taking longer than expected. Check your connection and try again.');
      }, timeoutMs);
    }

    window.addEventListener('message', function onDemoReady(event) {
      if (!event.data || event.data.type !== 'ss-demo-ready') return;
      if (!iframe.getAttribute('src')) return;
      try {
        var activeSrc = iframe.getAttribute('src') || iframe.getAttribute('data-src');
        if (!activeSrc) return;
        var expected = new URL(activeSrc, window.location.href).origin;
        if (event.origin !== expected && event.origin !== window.location.origin) return;
      } catch (e) {
        return;
      }
      if (loadingEl) loadingEl.hidden = true;
      if (gate) gate.hidden = true;
      if (iframe._ssDemoLoadTimer) clearTimeout(iframe._ssDemoLoadTimer);
      iframe.removeAttribute('aria-hidden');
      setStatus('');
      var frameWrap =
        iframe.closest('[data-calmly-kept-demo-frame]') ||
        iframe.closest('[data-clear-days-demo-frame]') ||
        iframe.closest('[data-budget-bills-demo-frame]');
      if (frameWrap) frameWrap.classList.add('is-loaded');
    });

    if (startBtn) {
      startBtn.addEventListener('click', function () {
        startBtn.disabled = true;
        beginLoad();
      });
    } else {
      beginLoad();
    }

    var retry = shell.querySelector('[data-ss-demo-page-retry]');
    if (retry) {
      retry.addEventListener('click', function () {
        iframe.removeAttribute('src');
        if (errorEl) errorEl.hidden = true;
        if (startBtn) {
          startBtn.hidden = false;
          startBtn.disabled = false;
          var previewRetry = gate && gate.querySelector('.ss-planner-demo-shell__preview');
          if (previewRetry) previewRetry.hidden = false;
          if (gate) gate.hidden = false;
        } else {
          beginLoad();
        }
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-ss-planner-demo-shell]').forEach(initShell);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (prefersReducedMotion()) {
    document.documentElement.classList.add('ss-demo-page--reduce-motion');
  }

  document.addEventListener('shopify:section:load', boot);
})();
